import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { getTranslationKey } from '../../modules/utils';
import { usePreventBodyPaddingShift } from '../../hooks/usePreventBodyPaddingShift';

interface IProps {
  isOpen: boolean;
  closeCallback: () => void;
}

export const InvoiceDownloadErrorModal: React.FC<IProps> = ({ isOpen, closeCallback }) => {
  usePreventBodyPaddingShift(isOpen);

  return (
    <Modal centered isOpen={isOpen} toggle={closeCallback} wrapClassName="modal-dark">
      <ModalHeader toggle={closeCallback}>
        {getTranslationKey('shop.orders.invoiceDownloadErrorModal.title')}
      </ModalHeader>
      <ModalBody>{getTranslationKey('shop.orders.invoiceDownloadErrorModal.text')}</ModalBody>
    </Modal>
  );
};
